import * as React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import getRoles from '../../adders/getRoles';
import { authActions } from '../../store/auth';
import { useState, useRef } from 'react';
import axios from 'axios';
import { styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import Alert from '@mui/material/Alert';



const Copyright = props => {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="/">
        Operadora Portuaria Centroamericana
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const Input = styled('input')({
  display: 'none',
});

const theme = createTheme();
const logo = require('../../assets/OPC-logo.webp');


const SignInSide = () => {
  const [isLoading, setLoading] = useState(false);
  const [isError, setError] = useState(false)
  const dispatch = useDispatch();
  const enteredUserRef = useRef();
  const enteredPasswordRef = useRef();
  const enteredCheckboxRef = useRef();


  const handleSubmit = event => {
    setLoading(true);
    event.preventDefault();
    const qs = require('qs');
    const enteredUser = enteredUserRef.current.value;
    const enteredPassword = enteredPasswordRef.current.value;
    const enteredCheckbox = enteredCheckboxRef.current.checked;

    const data = {
      username: enteredUser,
      password: enteredPassword,
      checked: enteredCheckbox
    }
    const options = {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    }
    axios.post('api/login', qs.stringify(data), options ).then( res => {
        setLoading(false);
        setError(false);
        const role = getRoles(res.data.privilegios);
        if( role.plan || role.news){
        dispatch(authActions.login({token: res.data.token.token, username: data.username, privilegios: role }));
       }else {
        setError(true);
        setLoading(false);
       }
    }).catch( error => {
      if(error.response.status !== 200){
        setLoading(false);
        setError(true);
      }
    })
  };


  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{ 
            backgroundImage: 'url("/lib/img/DSC_0713.webp");',
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
              <img src={logo} alt="OPC LOGO"/>
            <Typography component="h1" variant="h5">
              Administrador OPCWebPage
            </Typography>
            <Box component="form" Validate onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="user"
                label="Usuario"
                name="user"
                autoComplete="user"
                autoFocus
                inputRef={enteredUserRef}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Contraseña"
                type="password"
                id="password"
                autoComplete="current-password"
                inputRef={enteredPasswordRef}
              />
              <FormControlLabel
                control={<Checkbox  
                  name='checkbox'
                  color="primary"
                  inputRef={enteredCheckboxRef} 
                  />}
                label="Recuerdame"
              />
              <Button
               disabled={isLoading}
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Ingresar
              </Button>
              { isLoading === true ?
              <Box sx={{ width: '100%' }}>
                <LinearProgress />
              </Box> : null}
              { isError === true ? <Alert severity="error">Usuario o Contraseña no valido</Alert> : null}
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}

export default SignInSide;